import useTranslate from '@core/hooks/useTranslate';
import { ADMIN_WAREHOUSE_API_MENU } from '@root/core/constants/WarehouseApi/warehouse-api-menu';
import Imports from '@root/modules/WarehouseApi/pages/Import';
import Inventory from '@root/modules/WarehouseApi/pages/Inventory';
import OrderNormal from '@root/modules/WarehouseApi/pages/OrderNormal';
import OrderReturn from '@root/modules/WarehouseApi/pages/OrderReturn';
import Quotation from '@root/modules/WarehouseApi/pages/Quotation';

import { Layout, Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';

const { Sider, Content } = Layout;
interface Props {
  path?: string;
}

const WarehouseApiSideBar = ({ path = '' }: Props) => {
  const [t] = useTranslate();
  const [collapsed, setCollapsed] = useState(false);
  const [selected, setSeclected] = useState('');
  const [a, setA] = useState([] as any);
  const activeItem = (event: any) => {
    setSeclected(event.key);
  };
  const location = useLocation();

  useEffect(() => {
    let a = location;
    const b = a.pathname.replace('/admin/', '').split('/');
    setA(b);
  }, [location]);

  const colorParent = (item: {
    id: number;
    name?: string;
    label?: string;
    url: string;
    children?: { id: number; name: string; url: string }[];
  }) => {
    let isBold =
      !a[1] && item.url == '/admin/warehouse-api'
        ? 'bold'
        : a[1] == item.url.replace('/admin/warehouse-api/', '')
        ? 'bold'
        : !!a[1] &&
          a[1]
            .replace('/admin/warehouse-api/', '')
            .split('-')
            .includes(item.url.replace('/admin/warehouse-api/', ''))
        ? 'bold'
        : '500';
    return isBold;
  };

  const colorHasChild = (item: {
    id: number;
    name?: string;
    label?: string;
    url?: string;
    children: { id: number; name: string; url: string }[];
  }) => {
    let isbold = false;
    item.children.forEach((child) => {
      let bold =
        !!a[1] &&
        !a[2] &&
        a[1] == child.url.replace('/admin/warehouse-api/', '')
          ? true
          : !!a[2] &&
            a[2] == child.url.replace('/admin/warehouse-api/' + a[1] + '/', '')
          ? true
          : !!a[2] &&
            child.url.includes(a[1]) &&
            child.url
              .replace('/admin/warehouse-api/', '')
              .split('/')[0]
              .includes(a[1])
          ? true
          : false;
      if (bold) isbold = true;
    });
    return isbold ? 'bold' : '500';
  };

  const renderAdminOrStoreHeader = () => {
    return (
      <>
        <Layout className="navigation">
          <Sider collapsedWidth="48" width="230" className="side-bar__menu">
            <Menu
              mode="inline"
              style={{ height: '100%', borderRight: 0 }}
              selectedKeys={[path]}
            >
              {ADMIN_WAREHOUSE_API_MENU.map((item: any, index: number) => (
                <>
                  {item.children ? (
                    <Menu.SubMenu
                      title={item.label}
                      key={index + 200}
                      style={{ fontWeight: colorHasChild(item) }}
                    >
                      {item.children.map((child: any, idx: number) => (
                        <>
                          {child.children ? (
                            <Menu.SubMenu
                              title={child.label}
                              key={index + 400}
                              style={{ fontWeight: colorHasChild(child) }}
                            >
                              {child.children.map(
                                (childChild: any, childChildIdx: number) => (
                                  <Menu.Item
                                    key={idx + index * 10 + childChildIdx * 10}
                                  >
                                    <Link
                                      to={childChild.url}
                                      style={{
                                        fontWeight:
                                          childChild.url ===
                                            location.pathname ||
                                          (childChild.hiddenChildren &&
                                            childChild.hiddenChildren.find(
                                              (h: any) =>
                                                h.url === location.pathname ||
                                                h.url.test(location.pathname)
                                            ))
                                            ? 'bold'
                                            : '500'
                                      }}
                                    >
                                      {t(childChild.name)}
                                    </Link>
                                  </Menu.Item>
                                )
                              )}
                            </Menu.SubMenu>
                          ) : (
                            <Menu.Item key={idx + index * 10}>
                              <Link
                                to={child.url}
                                style={{
                                  fontWeight:
                                    !!a[1] &&
                                    !a[2] &&
                                    a[1] ==
                                      child.url.replace(
                                        '/admin/warehouse-api/',
                                        ''
                                      )
                                      ? 'bold'
                                      : (!!a[2] &&
                                          (a[2] ==
                                            child.url.replace(
                                              '/admin/warehouse-api/' +
                                                a[1] +
                                                '/',
                                              ''
                                            ) ||
                                            (!isNaN(a[2]) &&
                                              child.url.replace(
                                                '/admin/warehouse-api/' + a[1],
                                                ''
                                              ) == ''))) ||
                                        (child.hiddenChildren &&
                                          child.hiddenChildren
                                            .map((v: any) => v.url)
                                            .includes(location.pathname))
                                      ? 'bold'
                                      : '500'
                                }}
                              >
                                {t(child.name)}
                              </Link>
                            </Menu.Item>
                          )}
                        </>
                      ))}
                    </Menu.SubMenu>
                  ) : (
                    <Menu.Item
                      className={'menu-nav'}
                      title={item.label}
                      onClick={(event) => activeItem(event)}
                      key={index + 300}
                    >
                      <Link
                        key={item.id + 1000}
                        to={item.url}
                        style={{
                          color:
                            selected === `tmp_key-${index}` ? '#0077ff' : '',
                          fontWeight: colorParent(item)
                        }}
                      >
                        {t(item.name)}
                      </Link>
                    </Menu.Item>
                  )}
                </>
              ))}
            </Menu>
          </Sider>
          <Layout>
            <Content
              style={{
                minHeight: 280,
                minWidth: 1080,
                overflow: 'scroll'
              }}
            >
              <Switch>
                <Route exact={true} path="/admin/warehouse-api/quotation">
                  <Quotation />
                </Route>
                <Route exact={true} path="/admin/warehouse-api/import">
                  <Imports />
                </Route>
                <Route exact={true} path="/admin/warehouse-api/inventory">
                  <Inventory />
                </Route>
                <Route exact={true} path="/admin/warehouse-api/product"></Route>
                <Route exact={true} path="/admin/warehouse-api/order/normal">
                  <OrderNormal />
                </Route>
                <Route exact={true} path="/admin/warehouse-api/order/return">
                  <OrderReturn />
                </Route>

                <Route path="">
                  <Redirect to="/admin/warehouse-api/quotation" />
                </Route>
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </>
    );
  };

  return renderAdminOrStoreHeader();
};

export default React.memo(WarehouseApiSideBar);
